import { useEffect, useRef } from 'react';
import { useAuth } from 'src/hooks/auth/use-auth'; // ตรวจสอบว่า path ถูกต้อง

export const useIdleTimeout = (timeout) => {
    const { signOutDueToIdle } = useAuth();
    const timer = useRef(null);

    // ประกาศตัวแปร events ภายในฟังก์ชัน
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

    const resetTimer = () => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            console.log(`User idle for ${timeout / 1000} seconds. Signing out...`);
            signOutDueToIdle();
        }, timeout);
    };

    useEffect(() => {
        // เริ่มจับเวลาและเพิ่ม event listeners
        resetTimer();
        events.forEach(event => window.addEventListener(event, resetTimer));

        // Cleanup function: จะทำงานเมื่อ component ถูก unmount
        // หรือเมื่อค่าใน dependency array (timeout, signOut) เปลี่ยนไป
        return () => {
            if (timer.current) {
                clearTimeout(timer.current);
            }
            events.forEach(event => window.removeEventListener(event, resetTimer));
        };
    }, [timeout, signOutDueToIdle]); // dependency array ถูกต้องแล้ว

    return null;
};
